import React from 'react';
import BallButton from './BallButton.js';
import AppConstants from './../constants/AppConstants';
import AppDispatcher from './../dispatcher/AppDispatcher';
import SortButtonStore from './../stores/SortButtonStore';


/**
 * SortButton component
 * The top level component for the app
 * @class
 */
const SortButton = React.createClass({
  displayName: 'SortButton',
  categoryIteration: 0,
  buttonPressed: false,
  removeRotateClassTimeout: 0,
  animating: false,
  resetTimeout: 0,


  propTypes: {
    data: React.PropTypes.array.isRequired,
    touch: React.PropTypes.bool.isRequired,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      selectedCategory: this.props.data[0],
      shakeClass: '',
      rotateClass: '',
    };
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    // const releaseEvent = this.props.touch ? 'touchend' : 'mouseup';

    SortButtonStore.addChangeListener(this._onChange);
    // window.addEventListener(releaseEvent, this._onRelease);
  },


  /**
   * Called right before component unmounts from DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    // const releaseEvent = this.props.touch ? 'touchend' : 'mouseup';

    SortButtonStore.removeChangeListener(this._onChange);
    // window.removeEventListener(releaseEvent, this._onRelease);
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  render() {
    const showClass = this.state.show ?
      ' show' : '';
    const className = 'component-sort-button' + showClass +
      this.state.shakeClass + this.state.rotateClass;

    return (
      React.createElement("div", {className: className}, 
        React.createElement(BallButton, {
          touch: this.props.touch, 
          refreshIcon: true, 
          touchStartHandler: this._onPress, 
          touchEndHandler: this._onRelease}
        )
      )
    );
  },


  /**
   * Press handler for option buttons
   * @returns {undefined} undefined
   */
  _onPress() {
    clearTimeout(this.removeRotateClassTimeout);

    this.buttonPressed = true;

    this.setState({
      shakeClass: ' shake',
      rotateClass: '',
    });
  },


  /**
   * Press handler for option buttons
   * @returns {undefined} undefined
   */
  _onRelease() {
    const _this = this;

    if (!this.animating && this.buttonPressed) {
      this.animating = true;
      this.categoryIteration++;
      if (this.categoryIteration === this.props.data.length) {
        this.categoryIteration = 0;
      }

      const category = this.props.data[this.categoryIteration];

      this.setState({
        rotateClass: ' rotate',
      });

      AppDispatcher.handleViewAction({
        actionType: AppConstants.SET_CATEGORY,
        category,
      });
    }

    this.buttonPressed = false;
    this.setState({
      shakeClass: '',
    });

    this.removeRotateClassTimeout = setTimeout(function () {
      _this.setState({ rotateClass: '' });
    }, 710);

    this.resetTimeout = setTimeout(function () {
      _this.animating = false;
    }, 10);
  },

  /**
   * Cancels the sort if the button has been pressed
   * @returns {undefined} undefined
   */
  _releaseWithoutSort() {
    this.buttonPressed = false;
    this.animating = false;
    this.setState({
      shakeClass: '',
    });
  },


  /**
   * Called when a CHANGE event is emitted from the SortButtonStore
   * @returns {undefined} undefined
   */
  _onChange() {
    this.setState(SortButtonStore.getState());
  },
});


export default SortButton;
